import { Disclosure, RadioGroup } from "@headlessui/react"
import { memo, useMemo, useState } from "react"
import { BiCommentDetail } from "react-icons/bi"
import { BsArrowReturnLeft } from "react-icons/bs"
import { FaCheck } from "react-icons/fa"
import { HiBuildingOffice } from "react-icons/hi2"
import { IoIosArrowDown } from "react-icons/io"
import Modal from "../../../components/Modal"
import { Department, ReceiptApprover } from "../../../models"

const RejectApproval = ({
  show,
  setShow,
  onActionConfirm,
  productionOrder,
  department
}: {
  show: boolean,
  setShow: (show: boolean) => void,
  onActionConfirm: (returnDepartment: ReceiptApprover, comment: string) => void,
  productionOrder: string,
  department: Department
}) => {
  const [ rejectDepartment, setRejectDepartment ] = useState(ReceiptApprover.PD)
  const [ comment, setComment ] = useState<string>('')

  const approverDepartments = useMemo(() => {
    let idxApprover = 0
    switch(department) {
      case Department.PRODUCTION:
        idxApprover = 0
        break
      case Department.QC:
        idxApprover = 1
        break
      case Department.WAREHOUSE:
        idxApprover = 2
        break
      case Department.FA:
        idxApprover = 3
        break
      default:
        break
    }
    return Object.keys(ReceiptApprover).filter(k => k !== ReceiptApprover.FA).map((k, i) => (
      { department: k, disabled: i >= idxApprover }
    ))
  }, [ department ])

  return <Modal show={show} cancelText='ยกเลิก'
    onHide={() => setShow(false)}
    okText="ยืนยันไม่อนุมัติ"
    okTheme='danger'
    okAction={() => onActionConfirm(rejectDepartment, comment)}
    title={`คุณกำลังไม่อนุมัติใบ Receipt ของ ${productionOrder}`}
    maxWidth={'max-w-lg'}
    okDisable={comment === ''}
    >
    <div className="flex items-center gap-6">
      <BsArrowReturnLeft size={48} className="text-red-600"/>
      <div className="w-full space-y-3 ">
        <div>
          <Disclosure>
            {({ open }) => (
              <>
                <Disclosure.Button className="flex items-center gap-3">
                  <p className="flex items-center gap-1"><HiBuildingOffice size={20} />แผนกที่รับเรื่อง : <span className="font-bold ">{rejectDepartment}</span></p>
                  <IoIosArrowDown
                    className={`${
                      open ? 'rotate-180 transform' : ''
                    } h-5 w-5`}
                  />
                </Disclosure.Button>
                <Disclosure.Panel className="py-4">
                  <RadioGroup value={rejectDepartment} onChange={setRejectDepartment}>
                    <div className="grid grid-cols-3 gap-3">
                      {approverDepartments.map((dep) => (
                        <RadioGroup.Option
                          key={dep.department}
                          value={dep.department}
                          disabled={dep.disabled}
                          className={({ active, checked, disabled }) =>
                            `${checked ? 'border-red-500' : 'border-gray-100 bg-white'}
                              relative flex cursor-pointer rounded-lg px-5 py-4 shadow-md border focus:outline-none
                              ${disabled ? ' cursor-not-allowed opacity-50' : ''}`
                          }
                        >
                          {({ active, checked }) => (
                            <>
                              <div className="flex items-center justify-between w-full">
                                <div className="flex items-center">
                                  <div className="text-sm">
                                    <RadioGroup.Label
                                      as="p"
                                      className={`${
                                        checked ? 'text-red-500 font-bold' : 'text-gray-900'
                                      }`}
                                    >
                                      {dep.department}
                                    </RadioGroup.Label>
                                  </div>
                                </div>
                                {checked && (
                                  <div className="text-red-500 shrink-0">
                                    <FaCheck size={16}/>
                                  </div>
                                )}
                              </div>
                            </>
                          )}
                        </RadioGroup.Option>
                      ))}
                    </div>
                  </RadioGroup>
                </Disclosure.Panel>
              </>
            )}
          </Disclosure>
        </div>
        <div className="space-y-1">
          <p className="flex items-end gap-1"><BiCommentDetail size={20}/>เหตุผล</p>
          <textarea className={`input-form-text`} placeholder="กรุณากรอกเหตุผลการไม่อนุมัติ" value={comment} onChange={(e) => setComment(e.currentTarget.value)} >
          </textarea>
        </div>
      </div>
    </div>
  </Modal>
}

export default memo(RejectApproval)